// utils/helpers.js

export const toTitleCase = (str) => {
  if (!str) return "N/A";
  return /^[a-z\s]+$/.test(str)
    ? str.replace(/\b\w/g, (char) => char.toUpperCase())
    : str;
};

export const isAcademicScholarship = (s) =>
  s &&
  (s.award_type === "Scholarship" ||
    s.priority1 === "Academic" ||
    s.priority2 === "Academic" ||
    s.priority3 === "Academic");

export const isBursaryScholarship = (s) =>
  s &&
  (s.award_type === "Bursary" ||
    s.priority1 === "Financial Need" ||
    s.priority2 === "Financial Need" ||
    s.priority3 === "Financial Need");

export const formatCurrency = (value) => {
  if (!value || isNaN(value)) return "N/A";
  return `$${Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
  })}`;
};

const DEBUG = process.env.REACT_APP_DEBUG === "yes";
export const debugLog = (...args) => {
  if (DEBUG) console.log(...args);
};

export const schoolColorsNanaimo = {
  "John Barsby Community Secondary": "#FFDDC1",
  Cedar: "#C1FFD7",
  "Dover Bay Secondary": "#FFC1C1",
  IslandConnectED: "#D1C1FF",
  Alternate: "#C1E1FF",
  "Nanaimo District Secondary": "#FFD1E1",
  "Wellington Secondary": "#E1FFC1",
};

export const schoolColorsLadysmith = {
  "Ladysmith Secondary": "#FFD1E1",
};
